module.exports = __webpack_public_path__ + "img/pic_6.9f87ef1b.jpg";